import { useHistory } from "react-router-dom";
import styles from './index.module.css';
import { Box, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../store';
import { useTranslation } from 'react-i18next';
import DirectionsCarIcon from "@material-ui/icons/DirectionsCar";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import { BookingStatus } from "../../../../reducers/bookings/types";

export interface IActiveVehicle {
  activeBookings: number
  activeVehicles: number
}

const ActiveVehicleCard = ({ data }: { data: IActiveVehicle }) => {
  const history = useHistory();
  const userState = useSelector((state: IAppState) => state.authReducer.user)
  const consumerState = useSelector((state: IAppState) => state.consumerWebsiteReducer)
  const { locale, currency } = consumerState.consumerWebsite.organisation
  const { t } = useTranslation()

  return (
    <Box className={styles.enhancedCard}>
      <Box className={styles.cardContentEnhanced}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" style={{ fontWeight: 600, color: "#1e293b", fontSize: "18px" }}>
            {t("root:activeVehiclesCount")}
          </Typography>
          <Box className={styles.metricIcon} style={{ background: "linear-gradient(135deg, #059669, #10b981)" }}>
            🚗
          </Box>
        </Box>

        <Box style={{ marginTop: "10px" }}>
          <Box
            display="flex"
            justifyContent="space-between"
            style={{ gap: "16px" }}
          >
            {/* Active Bookings */}
            <Box
              style={{
                flex: 1,
                textAlign: "center",
                padding: "20px 10px",
                borderRadius: "12px",
                background: "#f9fafb",
                border: "1px solid #e5e7eb",
                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
              }}
            >
              <Box
                style={{
                  width: "48px",
                  height: "48px",
                  margin: "0 auto 12px",
                  borderRadius: "50%",
                  background: "#ecfdf5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <EventAvailableIcon style={{ color: "#059669" }} />
              </Box>
              <Typography
                variant="h2"
                style={{
                  fontWeight: 700,
                  color: "#059669",
                  fontSize: "32px",
                  lineHeight: "1.2",
                  marginBottom: "6px",
                  cursor: "pointer"
                }}
                onClick={() => {
                  history.push("/account/bookings", {
                    showActiveBookings: true
                  })
                }}
              >
                {data.activeBookings}
              </Typography>
              <Typography
                variant="body2"
                style={{ color: "#64748b", fontSize: "13px" }}
              >
                {t("root:totalActiveBookings")}
              </Typography>
            </Box>

            {/* Active Vehicles */}
            <Box
              style={{
                flex: 1,
                textAlign: "center",
                padding: "20px 10px",
                borderRadius: "12px",
                background: "#f9fafb",
                border: "1px solid #e5e7eb",
                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
              }}
            >
              <Box
                style={{
                  width: "48px",
                  height: "48px",
                  margin: "0 auto 12px",
                  borderRadius: "50%",
                  background: "#f0fdf4",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <DirectionsCarIcon style={{ color: "#16a34a" }} />
              </Box>
              <Typography
                variant="h2"
                style={{
                  fontWeight: 700,
                  color: "#16a34a",
                  fontSize: "32px",
                  lineHeight: "1.2",
                  marginBottom: "6px",
                  cursor: "pointer"
                }}
                onClick={() => history.push("/account/vehicles", {
                  showActiveVehicles: true
                })}
              >
                {data.activeVehicles}
              </Typography>
              <Typography
                variant="body2"
                style={{ color: "#64748b", fontSize: "13px" }}
              >
                {t("root:totalVehicles")}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ActiveVehicleCard